<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="change-address-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                Change repair address
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">

            <template v-if="!loading">
                <!-- Error alert -->
                <div class="alert alert-danger" v-if="error && !success">
                    <animated-error size="md" class="mr-2"></animated-error>
                    <div class="alert-content">
                        {{ error }}
                    </div>
                </div>

                <!-- Postcode input -->
                <div class="row form-group" v-if="partnerEnvironment !== 'likewize-au' && partnerEnvironment !== 'wefix-au'">
                    <div class="col-12">
                        <label>Enter postcode</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control text-uppercase" v-model="newPostcode">
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-primary postcode-search" @click="fetchAddresses(newPostcode)">Search</button>
                    </div>
                </div>

                <!-- Address select -->
                <div class="form-group" v-if="addresses.length > 0">
                    <label>Select your address</label>
                    <select class="custom-select form-control" v-model="addressKey" @change="setAddress()">
                        <option value="default" disabled selected>Please select an address from the list</option>
                        <option v-for="(address, key) in addressStrings" :key="key" :value="key">{{ address }}</option>
                    </select>
                </div>

                <!-- Address Form -->
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>Address line 1<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Address 1" v-model="order.details.address_1">
                        </div>
                        <div class="form-group">
                            <label>Address line 2</label>
                            <input type="text" class="form-control" placeholder="Address 2" v-model="order.details.address_2">
                        </div>
                        <div class="form-group">
                            <label>Town / City<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Town" v-model="order.details.town">
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label>Postcode<span class="text-danger">*</span></label>
                            <input type="text" class="form-control text-uppercase" placeholder="Postcode" v-model="order.details.postcode">
                        </div>
                    </div>
                </div>

                <!-- Footer buttons -->
                <button class="btn btn-success btn-block btn-lg" @click="save()">Update address</button>
                <button class="btn btn-link btn-block" @click="$bvModal.hide('change-address-modal')">Cancel</button>
            </template>

            <empty-state
                v-if="loading"
                statusIcon="loading"
                title="Updating your address"
                subtitle="This'll just take a minute..."
            ></empty-state>

        </div>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        props:["order"],

        data() {
            return {
                addresses:[],
                addressKey:null,
                addressStrings:[],
                customerEmail: null,
                error: null,
                loading: false,
                newPostcode:null,
                success: false,
            }
        },

        computed: {
            ...mapGetters([
                'partnerEnvironment'
            ])
        },

        methods: {
            ...mapActions([
                "changeOrderAddress",
                "displayToast"
            ]),

            /** Get the addresses */
            fetchAddresses(postcode) {
                this.addressStrings = [];
                this.addresses = [];
                this.$http.get(`/api/repair/order/addresses/${postcode}`)
                    .then(response => {

                        this.formatAddresses(response.data.data);

                        this.addresses = response.data.data;
                    });
            },

            /** Format Addresses in to a string  */
            formatAddresses(addresses) {
                addresses.forEach(address => {

                    let string = "";

                    if (address.line_1 !== "") {
                        string += address.line_1;
                    }

                    if (address.line_2 !== "") {
                        string += ", " + address.line_2;
                    }

                    if (address.line_3 !== "") {
                        string += ", " + address.line_3;
                    }

                    if (address.post_town !== "") {
                        string += ", " + address.post_town;
                    }

                    if (address.county !== "") {
                        string += ", " + address.county;
                    }

                    this.addressStrings.push(string);
                });
            },

            /** Build line 2 of the address */
            getLine2(address) {
                if (!address.line_2) {
                    return "";
                }

                if (address.line_2 === "") {
                    return "";
                }

                let line2 = address.line_2;

                if (address.line_3 === "") {
                    return line2;
                }

                return line2 + ", " + address.line_3;
            },

            /** Save address */
            save() {
                this.loading = true;

                this.changeOrderAddress({
                    order: this.order
                }).then(() => {
                    this.loading = false;
                    this.success = true;
                    this.$bvModal.hide("change-address-modal")
                    this.displayToast({text: 'Your address has been updated', type: 'success'});
                }).catch(error => {

                    if (error.response.data.code === "OR03") {
                        this.error = "Sorry there is no technician in that area.";
                    }

                    if (error.response.data.code === "OR04") {
                        this.error = "Your selected booking date is not available in this area, please change your booking date first.";
                    }

                    this.loading = false;

                    setTimeout(() => {
                        this.error = false;
                    }, 10000)
                });
            },

            /** Set address in inputs */
            setAddress() {
                let address = this.addresses[this.addressKey];
                this.order.details.address_1 = address.line_1;
                this.order.details.address_2 = this.getLine2(address);
                this.order.details.town = address.post_town;
                this.order.details.postcode = this.newPostcode;
            },
        }
    }
</script>

<style scoped>

</style>